import { connect } from 'react-redux'
import { Dispatch } from 'redux'

import {
  setUserAudioMuteStatus,
  setUserAudioVolumeLevel
} from '../../../common/actions/user/preference'

import { IRootState } from '../../../common/reducers'

import AudioControls from './audioControls'

interface IStateProps {
  muted: boolean
  volumeLevel: number
}

interface IDispatchProps {
  onMute: () => any
  onUnmute: () => any
  setVolumeLevel: (volumeLevel: number) => any
}

const mapStateToProps = (state: IRootState): IStateProps => {
  const {
    user: { preferences }
  } = state

  return {
    muted: preferences.searchAudioMuted,
    volumeLevel: preferences.searchAudioVolumeLevel
  }
}

const mapDispatchToProps = (dispatch: Dispatch<IRootState>) => {
  return {
    onMute: () => dispatch(setUserAudioMuteStatus(true)),
    onUnmute: () => dispatch(setUserAudioMuteStatus(false)),
    setVolumeLevel: (level: number) => dispatch(setUserAudioVolumeLevel(level))
  }
}
const AudioControlsContainer = connect<IStateProps, IDispatchProps, IRootState>(
  mapStateToProps,
  mapDispatchToProps
)(AudioControls)

export default AudioControlsContainer
